import React, { useContext, useEffect, useState } from "react";
import { Button, Container, Modal, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";

const BrandProfileDropdown = () => {
  const { auth, logOut } = useContext(Auth);
  const [show, setShow] = useState(false);

  const handleLogout = () => {
    let config = {
      url: ApiUrl.brandLogout,
    method: "POST",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        logOut();
        console.log(res);
      },
      (err) => {
        logOut();
      }
    );
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  return (
    <>
    <div className="user-avatar-box">
        <img src={auth.user?.avatar} alt="user" />
      </div>
    <NavDropdown
    title={<span className="drop-title">{auth.user?.owner_name}</span>}
    >
      <NavDropdown.Item>
        <Link to="/brand/account">Account</Link>
      </NavDropdown.Item>
      <NavDropdown.Item>
        <span onClick={handleShow}>Sign Out</span>
      </NavDropdown.Item>
    </NavDropdown>
    <Modal
          show={show}
          onHide={handleClose}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="sign-out-modal"
        >
          <Modal.Body>
            <p className="sign-out-text">
             Are You Sure You Want To Log Out ?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} className="no-btn">No</Button>
            <Button className="yes-btn" onClick={handleLogout}>Yes</Button>
          </Modal.Footer>
        </Modal>
    </>
  );
};

export default BrandProfileDropdown;
